import React from 'react';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux'; 
import { searchFacetChange, resetFacets } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const SELECTED_FILTER = "selected-filter"

const FilterTags = ({ facetFilters, navigationTheme, onReset }) => {
  const dispatch = useDispatch();

  const selectedFacetGroup = facetFilters.filter(
    (filter) => filter.selectedOptions.length > 0
  );

  const selectedFacetOption = selectedFacetGroup.reduce(
    (accumulator, group) => {
      if (!group) return accumulator;
      
      const { options, selectedOptions } = group;
      const groupOptions = options
        .filter((option) => selectedOptions.includes(option.id))
        .map((option) => ({ ...option, group }));
      return [...accumulator, ...groupOptions];
    },
    []
  );
  
  const handleFacetClick = (group) => dispatch(searchFacetChange(group))
  const handleFilterTagClick = (option) =>
    dispatch(searchFacetChange(option.group, option));

  if (selectedFacetGroup.length === 0) return null;

  return (
    <div className="selected-filter">
      { navigationTheme !== 'filter' && (
      <span className="hide-for-large">
        <span className='selected-filter__your-filters'>{translate('search.yourfilter')}:</span>
        {selectedFacetGroup &&
          selectedFacetGroup.map((group, index) => (
            <button
              type="button"
              className={`${SELECTED_FILTER}__tag`}
              onClick={() => handleFacetClick(group)}
              key={`group-${index}`}
            >
              {` ${group.id} `}
            </button>
          ))}
      </span> )}
      {navigationTheme === 'filter' && (
        <div className='selected-filter__wrapper'>
          <span className='selected-filter__your-filters'>{translate('search.yourfilter')}:</span>
          {selectedFacetOption &&
            selectedFacetOption.map((option, index) => (
              <button
                type="button"
                className="selected-filter__tag"
                onClick={() => handleFilterTagClick(option)} 
                key={`option-${index}`}
              >
                {` ${option.id} `}
              </button>
            ))}
        </div>
      )}
      <span>
        {selectedFacetGroup.length > 0 && (
          <li className="faceted-search__group" key="reset">
            <button
              type="button"
              className="selected-filter__clear-all-button"
              onClick={() => onReset(facetFilters)}
            >
              {translate('filters.clear.all')}
            </button>
          </li>
        )}
      </span> 
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onReset: (allFilters) => dispatch(resetFacets(allFilters)),
  };
};

export default connect(null, mapDispatchToProps)(FilterTags); 